module.exports = __webpack_public_path__ + "static/media/blue.f4e5376c.png";